
const slotIdsSelector = state => state.urlParams.slots;
const embeddedInPortalSelector = state => state.urlParams.embeddedInPortal;

module.exports = {
    slotIdsSelector,
    embeddedInPortalSelector
};
